export const Reports = {
  Name: "Звіти",
  Emoji: "📃",
  Search: {
    PLACEHOLDER: "Пошук звітів",
    NO_OPTIONS: "Звітів не знайдено",
  },
};
